import "./orderTrack.css";
import { useUpdateOrderMutation } from "../../services/orderApi";
import { useState } from "react";
import { LocalShipping, House, Cancel } from "@mui/icons-material";
import { FaBoxOpen } from 'react-icons/fa';
import { CgNotes } from 'react-icons/cg';
import { BsCheckCircle } from 'react-icons/bs';
import { useConfirm, useToast, FieldError } from "../../components/ui";

function OrderTrack(props) {
  const [updateOrder] = useUpdateOrderMutation();
  const confirm = useConfirm();
  const toast = useToast();

  const [data, setdata] = useState({
    id: props.data.order_Id,
    order_Status: props.data.order_Status,
  });
  const [error, setError] = useState('');

  if (data.order_Status === "Canceled") {
    return (
      <div className="main">
        <ul>
          <li>
            <CgNotes className="icon" />
            <div className="canceldOrder1"><Cancel /></div>
            <p className="text">Order Placed</p>
          </li>
          <li>
            <FaBoxOpen className="icon" />
            <div className="canceldOrder"><Cancel /></div>
            <p className="text">Under Package</p>
          </li>
          <li>
            <LocalShipping className="icon" />
            <div className="canceldOrder"><Cancel /></div>
            <p className="text">On The way to deliver</p>
          </li>
          <li>
            <House className="icon" />
            <div className="canceldOrder"><Cancel /></div>
            <p className="text">Delivered</p>
          </li>
          <li>
            <Cancel className="icon" />
            <div className="canceldOrder"><BsCheckCircle /></div>
            <p className="text">Canceled</p>
          </li>
        </ul>
      </div>
    )
  }

  // These must match the real order_Status values used everywhere else in
  // the app (ORDER_STATUS_VARIANT, Orders.jsx, WidgetLg) - this previously
  // checked for "Order Placed"/"Delivered", which never matched the real
  // "Order Pending"/"Deliverd" values, so the tracker never advanced past
  // step 0 for a pending order and never reached step 4 for a delivered one.
  let activeBar = 0;
  if (data.order_Status === "Order Pending") {
    activeBar = 1;
  } else if (data.order_Status === "Under Package") {
    activeBar = 2;
  } else if (data.order_Status === "On The way to deliver") {
    activeBar = 3;
  } else if (data.order_Status === "Deliverd") {
    activeBar = 4;
  }

  const handleKeyActivate = (e, orderStatus) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleUpdate(orderStatus);
    }
  };

  const handleUpdate = async (orderStatus) => {
    const actualData = { id: data.id, order_Status: orderStatus }
    const previousStatus = data.order_Status
    const ok = await confirm({
      title: `Update order status to ${orderStatus}`,
      message: "Are you sure you want to update the order status?",
    });
    if (!ok) return;

    setdata({ id: data.id, order_Status: orderStatus })
    const res = await updateOrder(actualData)
    if (res.error) {
      setdata({ id: data.id, order_Status: previousStatus })
      const message = res.error.data?.order_Status?.[0] || 'Could not update order status.'
      setError(message)
      toast.error(message)
    }
    if (res.data) {
      setError('')
      toast.success(`Order status updated to ${orderStatus}.`)
    }
  }

  return (
    <div className="main">
      <FieldError>{error}</FieldError>
      <ul>
        <li>
          <CgNotes className="icon" />
          <div
            className={activeBar >= 1 ? " progress one active" : " progress one"}
            onClick={() => handleUpdate("Order Pending")}
            onKeyDown={(e) => handleKeyActivate(e, "Order Pending")}
            role="button"
            tabIndex={0}
            aria-label="Mark order as Order Placed"
          > <BsCheckCircle className="uil" />
          </div>
          <p className="text">Order Placed</p>
        </li>
        <li>
          <FaBoxOpen className="icon" />
          <div
            className={activeBar >= 2 ? " progress two active" : " progress two"}
            onClick={() => handleUpdate("Under Package")}
            onKeyDown={(e) => handleKeyActivate(e, "Under Package")}
            role="button"
            tabIndex={0}
            aria-label="Mark order as Under Package"
          >
            <BsCheckCircle className="uil" />
          </div>
          <p className="text">Under Package</p>
        </li>
        <li>
          <LocalShipping className="icon" />
          <div
            className={activeBar >= 3 ? " progress three active" : " progress three"}
            onClick={() => handleUpdate("On The way to deliver")}
            onKeyDown={(e) => handleKeyActivate(e, "On The way to deliver")}
            role="button"
            tabIndex={0}
            aria-label="Mark order as On The way to deliver"
          >
            <BsCheckCircle className="uil" />
          </div>
          <p className="text">On The way to deliver</p>
        </li>
        <li>
          <House className="icon" />
          <div
            className={activeBar >= 4 ? " progress four active" : " progress four"}
            onClick={() => handleUpdate("Deliverd")}
            onKeyDown={(e) => handleKeyActivate(e, "Deliverd")}
            role="button"
            tabIndex={0}
            aria-label="Mark order as Delivered"
          >
            <BsCheckCircle className="uil" />
          </div>
          <p className="text">Delivered</p>
        </li>
        <li>
          <div></div>
        </li>
      </ul>
    </div>
  );
}

export default OrderTrack;
